<template>
  <Button
    :is="tag"
    class="icon-button"
    :class="classes"
    :href="href"
    v-bind="$props"
    @click="(event) => $emit('click', event)"
  >
    <template #icon>
      <i :class="'icon icon-' + icon" />
    </template>
    <slot />
    <span v-if="number" class="icon-button__notification">{{ number }}</span>
  </Button>
</template>

<script>
import Button from "@/components/ButtonV2.vue";

export default {
  name: "IconButton",
  components: {
    Button,
  },
  extends: Button,
  props: {
    icon: {
      type: String,
      required: true,
    },
    iconPosition: {
      type: String,
      default: "left",
      validator(value) {
        return ["left", "right"].includes(value);
      },
    },
    textAlign: {
      type: String,
      default: "center",
      validator(value) {
        return ["left", "center", "right"].includes(value);
      },
    },
    notificationNumber: {
      type: Number,
      default: 0,
    },
  },
  emits: ["click"],
  computed: {
    classes() {
      return {
        "icon-button--has-text": Boolean(this.$slots.default),
        "icon-button--right": this.iconPosition === "right",
        "icon-button--text-left": this.textAlign === "left",
        "icon-button--text-right": this.textAlign === "right",
      };
    },
    number() {
      if (this.notificationNumber === 0) {
        return null;
      } else if (this.notificationNumber > 9) {
        return "9+";
      } else {
        return this.notificationNumber;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-button {
  display: flex !important;
  align-items: center;
  position: relative;

  .icon {
    font-size: 20px;
  }

  &--has-text {
    .icon {
      margin-right: 5px;
    }
  }

  &--right {
    flex-direction: row-reverse;

    .icon {
      margin-right: 0;
      margin-left: 5px;
    }
  }

  &__notification {
    position: absolute;
    color: $color-black;
    top: 0;
    right: 5px;
    @include utility-label(14px);

    .icon--has-text & {
      right: 0;
    }
  }

  :deep(.text) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
  }

  &--text-left :deep(.text) {
    justify-content: flex-start;
  }

  &--text-right :deep(.text) {
    justify-content: flex-end;
  }
}
</style>
